import styles from "assets/styles/pages/Login";

const { Popper } = require("@mui/material");

export default function CustomPopper(props) {
  return <Popper {...props} sx={styles.borderRadius10} placement="bottom" />;
}
